import * as contentful from "contentful";

function getEnv(hostname) {
    return hostname === "localhost"
        ? "local"
        : hostname === "kirkesok-test.azurewebsites.net"
            ? "test"
            : hostname === "kirkesok-preprod.azurewebsites.net"
                ? "staging"
                : "production";
}

function getApiUrl(env) {
    if (env === "test" || env === "local") {
        return "https://kirkesokapi-dev.azurewebsites.net";
    }
    return "https://kirkesokapi.azurewebsites.net/";
}

const ENV = getEnv(document.location.hostname);

// API url
const API_URL = getApiUrl(ENV);

// CF = Contentful. Space/token/environment are baked in at build time from
// REACT_APP_CONTENTFUL_* (see ci-cd-front-pipeline.yml) - each deployed bundle only ever
// contains the credentials for the environment it was built for.
const CF_SPACE_ID = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
const CF_TOKEN = process.env.REACT_APP_CONTENTFUL_DELIVERY_API_KEY;
const CF_ENVIRONMENT = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || "master";

if (!CF_SPACE_ID || !CF_TOKEN) {
    // eslint-disable-next-line no-console
    console.error(
        "Contentful is misconfigured: REACT_APP_CONTENTFUL_SPACE_ID / REACT_APP_CONTENTFUL_DELIVERY_API_KEY missing from the build. Contentful requests will fail."
    );
}

const CF_ROOT_URL = `https://cdn.contentful.com/spaces/${CF_SPACE_ID}`;
const CF_CONFIG = {
    space: CF_SPACE_ID,
    environment: CF_ENVIRONMENT,
    accessToken: CF_TOKEN,
};

const ContentfulClient = contentful.createClient(CF_CONFIG);

// Kirkesøk API config details
const ApiConfig = {
    widthCredentials: true,
    responseType: "json",
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
};

// Global title to be visbile at the browser tab
const MetaTitle = "- Kirkesøk";

export {
    ContentfulClient,
    ApiConfig,
    MetaTitle,
    API_URL,
    CF_ROOT_URL,
    CF_TOKEN,
    ENV,
    getEnv,
    getApiUrl,
};



// WEBPACK FOOTER //
// ./src/settings.js